import { useEffect, useState } from "react";

const RECEPTION = { open: 10 * 60, lunchStart: 12 * 60, lunchEnd: 13 * 60, close: 17 * 60 };

function getStatus() {
  const now = new Date();
  const parts = new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Stockholm", weekday: "short", hour: "2-digit", minute: "2-digit", hour12: false }).formatToParts(now);
  const get = (t) => parts.find((p) => p.type === t)?.value;
  const weekday = (get("weekday") || "").toLowerCase();
  const minutes = parseInt(get("hour"), 10) * 60 + parseInt(get("minute"), 10);
  const weekend = weekday.startsWith("lör") || weekday.startsWith("sön");
  if (weekend || minutes < RECEPTION.open || minutes >= RECEPTION.close) {
    return { label: "Stängt", tone: "closed", note: weekend ? "Öppnar måndag 10:00" : minutes < RECEPTION.open ? "Öppnar 10:00" : "Öppnar imorgon 10:00" };
  }
  if (minutes >= RECEPTION.lunchStart && minutes < RECEPTION.lunchEnd) {
    return { label: "Lunchstängt", tone: "lunch", note: "Öppnar igen 13:00" };
  }
  return { label: "Öppet nu", tone: "open", note: minutes < RECEPTION.lunchStart ? "Lunchstängt 12:00" : "Stänger 17:00" };
}

const tones = {
  open: { dot: "bg-emerald-500", badge: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  lunch: { dot: "bg-amber-500", badge: "bg-amber-50 text-amber-700 border-amber-200" },
  closed: { dot: "bg-rose-500", badge: "bg-rose-50 text-rose-700 border-rose-200" },
};

export default function ReceptionStatus({ dark = false }) {
  const [status, setStatus] = useState(getStatus);

  useEffect(() => {
    const t = setInterval(() => setStatus(getStatus()), 60000);
    return () => clearInterval(t);
  }, []);

  const tone = tones[status.tone];
  return (
    <div data-testid="reception-status" className={`mt-3 rounded-xl border p-3 ${dark ? "border-white/10 bg-white/5" : "border-slate-100 bg-[#f6f9fc]"}`}>
      <div className="flex items-center gap-2 flex-wrap">
        <span data-testid="reception-status-badge" className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-semibold ${tone.badge}`}>
          <span className={`w-2 h-2 rounded-full ${tone.dot} ${status.tone === "open" ? "animate-pulse" : ""}`} />
          Receptionen: {status.label}
        </span>
        <span className={`text-xs ${dark ? "text-slate-400" : "text-slate-500"}`}>{status.note}</span>
      </div>
      <p className={`text-xs mt-2 ${dark ? "text-slate-400" : "text-slate-500"}`} data-testid="reception-hours">
        Receptionens öppettider: vardagar 10:00 – 17:00 (lunchstängt 12:00 – 13:00). Helger obemannat – öppet för inbokade kurser och körlektioner.
      </p>
    </div>
  );
}
